/* import __COLOCATED_TEMPLATE__ from './design-new-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();